module.exports = __webpack_public_path__ + "right2.951d0b9f4417e889f988.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/right2.svg
// module id = 1296
// module chunks = 2